import { createContext, useEffect, useState } from 'react';
import { createBrowserRouter, Route, RouterProvider, Routes } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux"
import { Dispatch } from "redux"
import * as actions from './shared/StoreContainer/actionCreators';
import { Helmet } from "react-helmet"

import { Home, DemoPage } from './pages';

import { setUserId } from './shared/MetricApi';

import './App.css';

import { CommonConfig } from './appParams_common';
import { Config as SpecialConfig_VRI } from './appParams_VRI';
import { Config as SpecialConfig_IZHS } from './appParams_IZHS';
import { Config as SpecialConfig_OSM } from './appParams_OSM';
import { Config as SpecialConfig_OKS } from './appParams_OKS';
import { Config as SpecialConfig_Geocoder } from './appParams_Geocoder';
import { Config as SpecialConfig_FIAS } from './appParams_FIAS';
import { Config as SpecialConfig_VEGRN } from './appParams_VEGRN.js';
import { Config as SpecialConfig_oks3782 } from './appParams_oks3782.js';
import { NewDemo } from './pages/new_demo';
import { FiasPage } from './pages/fiasPage';

function getConfig() {
  if (window.location.href.toLowerCase().includes("wrongvri")) return SpecialConfig_VRI;
  if (window.location.href.toLowerCase().includes("izhsnotcadaster")) return SpecialConfig_IZHS;
  if (window.location.href.toLowerCase().includes("osmplus")) return SpecialConfig_OSM;
  if (window.location.href.toLowerCase().includes("oksgeocoded")) return SpecialConfig_OKS;
  if (window.location.href.toLowerCase().includes("violationsegrn")) return SpecialConfig_VEGRN; 
  if (window.location.href.toLowerCase().includes("fiasgeocoded")) return SpecialConfig_FIAS;
  if (window.location.href.toLowerCase().includes("3782")) return SpecialConfig_oks3782;
  if (window.location.href.toLowerCase().includes("geocoder")) return SpecialConfig_Geocoder;
  return SpecialConfig_oks3782;
}

export const Config = getConfig();  //SpecialConfig;

export const DeviceContext = createContext({ mobile: false });
export const UserContext = createContext({ user: null, id: null });

function App() {
  const dispatch: Dispatch<any> = useDispatch()

  //@ts-ignore
  const idInContainer = useSelector((state) => (state?.containerUser?.user?.id));
  //@ts-ignore
  const locationInContainer = useSelector((state) => (state?.containerLocation?.location?.name));

  const [id, setId] = useState<any>(null)

  useEffect(() => {
    setUserId(setId)
    dispatch(actions.setLayers(Config.layers));
    dispatch(actions.setBaseLayers(CommonConfig.baseLayers));

    // document.title = Config.texts.appName;
  }, [])

  useEffect(() => {
    id && dispatch(actions.getUserID(id))
    // eslint-disable-next-line
  }, [id])

  useEffect(() => {
    console.log(idInContainer)
  }, [idInContainer])

  useEffect(() => {
    console.log(locationInContainer)
  }, [locationInContainer])


  return (
    <>
      {
        window.location.href.toLowerCase().includes("geocoder")
          ? <NewDemo />
          : (
            window.location.href.toLowerCase().includes("fiasgeocoded")
            ? <FiasPage />
            : <Home />
          )
      }
    </>
  );
}

export default App;
